import React from "react";
import TableRow, { TableRowProps } from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";

const CustomTableRow = styled(TableRow)({
  "&:hover": {
    background: "#EFF6F2 !important",
    color: "#39d29f !important",
  },
  "&:hover > 	.MuiTableCell-root": {
    color: "#39d29f !important",
  },
});

export const TableHoverRow: React.FC<TableRowProps> = (props) => {
  const { children, ...otherProps } = props;
  return <CustomTableRow {...otherProps}>{children}</CustomTableRow>;
};
